import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

function Pagination({ data, onChange, isLoading }) {
  const canPrev = data.current_page > 1;
  const canNext = data.current_page < data.total_pages;
  const handlePrev = (e) => {
    e.preventDefault();
    if (isLoading || !canPrev) return;
    onChange(data.current_page - 1);
  };
  const handleNext = (e) => {
    e.preventDefault();
    if (isLoading || !canNext) return;
    onChange(data.current_page + 1);
  };
  const handleSetPage = (e) => {
    e.preventDefault();
    const promptPage = () => {
      const page = prompt(`Enter page (1 between ${data.total_pages})`, data.current_page); // eslint-disable-line
      if (page < 1 || page > data.total_pages || !page) {
        if (_.isEmpty(page || '')) {
          return false;
        }
        alert('Invalid page number!'); // eslint-disable-line
        return promptPage();
      }
      return page;
    };
    const newPage = promptPage();
    if (!newPage) return;

    onChange(newPage);
  };
  return (
    <div className="d-flex justify-content-between flex-wrap align-items-center">
      <div className="">
        <nav>
          <ul className="pagination mb-0">
            <li className={`page-item${isLoading || !canPrev ? ' disabled' : ''}`}>
              <a className="page-link cms-text-primary" href="/" onClick={handlePrev}>
                <i className="fa fa-angle-double-left" /> Prev
              </a>
            </li>
            <li className={`page-item${isLoading ? ' disabled' : ''}`}>
              <a className="page-link cms-text-primary" href="/" onClick={handleSetPage}>
                Page {data.current_page || 1} of {data.total_pages || 1}
              </a>
            </li>
            <li className={`page-item${isLoading || !canNext ? ' disabled' : ''}`}>
              <a className="page-link cms-text-primary" href="/" onClick={handleNext}>
                Next <i className="fa fa-angle-double-right" />
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}

Pagination.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  onChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

Pagination.defaultProps = {
  isLoading: false,
};

export default Pagination;
